import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { createProductDefaultDataBinding } from "@/libs/commerce/ProductContent";

import type { STANDARD_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS } from "./StandardProductDetailsContainer.inputs.builder";
import { ALL_STANDARD_PRODUCT_DETAILS_CONTAINER_INPUTS } from "./StandardProductDetailsContainer.inputs.builder";

export const StandardProductDetailsContainerComponent: RegisteredComponent = {
  name: "StandardProductDetailsContainer",
  friendlyName: "Standard Product Details Container",
  component: dynamic(async () => (await import("./StandardProductDetailsContainer")).StandardProductDetailsContainer),
  models: [getBuilderModelName("product")],
  defaults: {
    bindings: createProductDefaultDataBinding<Partial<typeof STANDARD_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS>>({
      bundlesConfig: "productBundlesConfig",
      categories: "productCategories",
      currentVariantId: "productCurrentVariantId",
      currentVariantSku: "productCurrentVariantSku",
      description: "productDescription",
      galleryAssets: "productGalleryAssets",
      isBundle: "productIsBundle",
      isMultiPackEnabled: "productIsMultiPackEnabled",
      isTrial: "productIsTrial",
      isTradeIn: "productIsTradeIn",
      knowMoreUrl: "productKnowMoreUrl",
      multiPackDescription: "productMultiPackDescription",
      multiPackName: "productMultiPackName",
      multiPackProducts: "productMultiPackProducts",
      productName: "productName",
      sku: "productSku",
      badgeText: "productBadgeText",
      trustpilot: "productTrustpilot",
      videoGallery: "productVideoGallery",
      configurableOptions: "productConfigurableOptions",
      nonTradeInSku: "productNonTradeInSku",
      hasRegistrationConsent: "productHasRegistrationConsent",
    }),
  },
  inputs: ALL_STANDARD_PRODUCT_DETAILS_CONTAINER_INPUTS,
};
